import React, { useContext } from "react";
import { useEffectOnce } from "@lib-shared/hooks";
import { appSettings } from "core/config";
import { BusinessPage } from "core/constants";
import { AppContext } from "core/context";
import { axiosLogger, sessionManager } from "core/instances";
import { LocalStorageHelper } from "core/lib/local-storage-helper";
import Style from "core/lib/style";
import UrlUtils from "core/lib/url-utils";
import { Notice } from "./common-ui";

type SignInProps = {
    returnUrl?: string | null;
    message?: string | null;
    email?: string | null;
}

const SignIn = (props: SignInProps) => {
    let { returnUrl, message = null } = props;
    const appContext = useContext(AppContext);

    const pageTitle = "Sign In";
    appContext.updateTitle(pageTitle);
    appContext.updateBodyCssName(Style.auth);

    if (!message) {
        message = "Redirecting to sign in";
    }

    const onLoad = () => {
        LocalStorageHelper.stampedLog("onLoad");

        const root = UrlUtils.getRootPath();

        const location = window.location;
        const searchParams = new URLSearchParams(location.search);

        const redirectUrl = searchParams.get("redirectUrl");

        if (redirectUrl != null) {
            returnUrl = redirectUrl;
        } else if (returnUrl == null) {
            returnUrl = `${root}${BusinessPage.dashboard.substring(1)}`;
        }

        //Remove everything from local storage & logs database
        const isEnabled = appSettings.isEnabled;

        if (isEnabled.logAllResponsesToDatabase || isEnabled.logErrorsToDatabase) {
            axiosLogger.clear();
        }

        LocalStorageHelper.logout();
        LocalStorageHelper.stampedLog("Sign In");

        sessionManager.signIn(returnUrl);
    }

    useEffectOnce(() => onLoad());

    return (
        <Notice showSpinner={true}>
            <p dangerouslySetInnerHTML={{ __html: message }} />
        </Notice>
    );
}

export default SignIn;
